// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";
// import Backend from "i18next-http-backend";
// import LanguageDetector from "i18next-browser-languagedetector";

// i18n.use(Backend).use(initReactI18next).use(LanguageDetector).init({
//   fallbackLng: "az",
//   // debug: true,
// });

// export default i18n;
// Example i18n initialization with LanguageDetector
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: localStorage.getItem("i18nextLng"),
    // debug: true,
    backend: {
      loadPath: `/locales/{{lng}}/translation.json`,
    },
  });

export default i18n;
